export const markSpaInteractionTime = (spaIntType) => {
    window.performance.mark(`spaIntTime-${spaIntType}`);
};

export const collectSpaIntTime = () => {
    const marks = window.performance.getEntriesByType('mark').filter((m) => m.name.includes('spaIntTime'));
    let timing = null;

    if (marks.length > 1) {
        const spaIntType = marks[0].name.replace('spaIntTime-', '');
        const spaIntTime = Math.round(marks[1].startTime - marks[0].startTime);

        timing = {
            spaIntType,
            spaIntTime,
        };
    }

    clearMarks(marks);

    return timing;
};

export const clearMarks = (marks) => {
    marks.map((m) => window.performance.clearMarks(m.name));
};
